<!-- Muestra la linea y el punto de volcado establecido. -->
<template>
  <div class="div-componenteInformacionCabecera">
    <f7-row
      class="row-componenteInformacionCabecera"
    >
      <f7-col>
        <span class="span-componenteInformacionCabecera"> {{ text }} </span>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
export default {
  name: 'PCInformacionCabecera',

  props: {
    text: { type: String, default: '' },
  },
};
</script>

<style scoped>
.div-componenteInformacionCabecera {
  color: #c0c0c0d6;
  background-color: #ffab00;
  padding-top: 10px;
  text-align: center;
  min-height: 35px;
  position: fixed;
  width: 100%;
  z-index: 1000;
  margin-top: 30px;
}

.span-componenteInformacionCabecera {
  font-size: 18px;
  opacity: 0.7;
  color: #fff;
}

.row-componenteInformacionCabecera {
  margin: 0;
  max-height: 45px;
}
</style>
